import { Col, Row, Space } from "antd";
import React, { useEffect, useImperativeHandle, useState } from "react";
import { columnsTableMenu } from "./SelectedCards.config";
import "./SelectedCards.scss";
import TableInputAdd from "./TableInputAdd/TableInputAdd";

const SelectedCards = React.forwardRef((props: any, ref) => {
  // redux

  //
  //
  const [dataSource, setDataSource] = useState<any>([]);

  useImperativeHandle(ref, () => ({
    setData: setDataSource,
    getData: () => {
      return dataSource;
    },
    validateFields: handleValidate,
  }));
  const handleValidate = async () => {
    let tmp = dataSource.find((it) => !it.soLuong || it.soLuong === "");
    if (tmp) return false;
    return true;
  };
  useEffect(() => {}, []);

  useEffect(() => {
    let tmp = 0;
    dataSource.map((it) => {
      if (it.soLuong) {
        tmp += it.giaBan * Number(it.soLuong);
      }
    });
    props.callPayment(tmp);
  }, [dataSource]);
  return (
    <div className="service-table-container">
      <Space direction="vertical" className="service-space">
        <Row gutter={[8, 8]}>
          <Col xs={24} md={24} sm={24} lg={24} xl={24}>
            <TableInputAdd
              column={columnsTableMenu}
              data={dataSource}
              pagination={false}
              setData={props.setCTRecord}
              // rowSelection={{
              //   onSelect: onSelectRow,
              //   selectedRowKeys: selectedRowKeys
              // }}
            />
          </Col>
        </Row>
      </Space>
    </div>
  );
});

export default SelectedCards;
